import { computed } from 'vue';
import { usePolicy } from 'dashboard/composables/usePolicy';
import {
  QA_REVIEW_PERMISSIONS,
  QA_POLICY_MANAGE_PERMISSIONS,
  QA_ALERT_MANAGE_PERMISSIONS,
  QA_SENSITIVE_EVIDENCE_VIEW_PERMISSIONS,
  QA_REPORT_VIEW_PERMISSIONS,
  QA_REPORT_EXPORT_PERMISSIONS,
  QA_REPORT_RERUN_PERMISSIONS,
  QA_AGENT_KPI_VIEW_PERMISSIONS,
} from 'dashboard/constants/permissions';

/**
 * Button-level QA permission gates aligned with QaDashboardPolicy.
 */
export function useQaPermissions() {
  const { checkPermissions } = usePolicy();

  const canReview = computed(() =>
    checkPermissions([
      'administrator',
      QA_REVIEW_PERMISSIONS,
      QA_POLICY_MANAGE_PERMISSIONS,
    ])
  );

  const canManagePolicies = computed(() =>
    checkPermissions(['administrator', QA_POLICY_MANAGE_PERMISSIONS])
  );

  const canManageAlerts = computed(() =>
    checkPermissions(['administrator', QA_ALERT_MANAGE_PERMISSIONS])
  );

  const canViewSensitiveEvidence = computed(() =>
    checkPermissions([
      'administrator',
      QA_SENSITIVE_EVIDENCE_VIEW_PERMISSIONS,
      QA_POLICY_MANAGE_PERMISSIONS,
    ])
  );

  const canViewReports = computed(() =>
    checkPermissions([
      'administrator',
      QA_REPORT_VIEW_PERMISSIONS,
      QA_REPORT_EXPORT_PERMISSIONS,
      QA_REPORT_RERUN_PERMISSIONS,
      QA_POLICY_MANAGE_PERMISSIONS,
    ])
  );

  const canExportReports = computed(() =>
    checkPermissions([
      'administrator',
      QA_REPORT_EXPORT_PERMISSIONS,
      QA_POLICY_MANAGE_PERMISSIONS,
    ])
  );

  const canRerunReports = computed(() =>
    checkPermissions([
      'administrator',
      QA_REPORT_RERUN_PERMISSIONS,
      QA_POLICY_MANAGE_PERMISSIONS,
    ])
  );

  const canViewAgentKpi = computed(() =>
    checkPermissions([
      'administrator',
      QA_AGENT_KPI_VIEW_PERMISSIONS,
      QA_POLICY_MANAGE_PERMISSIONS,
    ])
  );

  return {
    canReview,
    canManagePolicies,
    canManageAlerts,
    canViewSensitiveEvidence,
    canViewReports,
    canExportReports,
    canRerunReports,
    canViewAgentKpi,
  };
}
